import type { FaireProductEntity } from "../../entity_types/product";

export const p_88a84bo8: FaireProductEntity = {
  token: "p_88a84bo8",
  type: "product",
  name: "Fuck You Smiley Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/33120d78fd1033d9ab4477210a059411dfdd6d6cd23440fe87c8bf7d3060000b/1555103405.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b7d7266d912d93f82a32b1a70600307741ddfaf233c9d6711efd0d6eac573929/1531161966.jpg",
    "https://cdn.faire.com/fastly/53df89934cccf121b551a0a1d0a9ccfa60fcf9c3a20bc869d1f84047e1361e60.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/db35c85d6f9e779c67e013355fa4138d101e0e31b837df82249a1a60d9dac9a0/1555102234.jpg"
  ],
  priceDollars: 6.75,
  description: "Sometimes there’s only one thing left to say… FUCK YOU… but say it with a smile, and leave ‘em wanting more. Next time someone looks you up and down, flash this friendly message, and let them know what’s up.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:29.195Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
